import {Component} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {TableComponent} from "../../../utils/table/table.component";
import {AResourceTableComponent} from "../../../AResourceTableComponent";
import {RouteModel} from "../../../../models/resources/route.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormGroupHelper} from "../../../../helpers/form-group-helper";
import {TableColumnModel} from "../../../../models/table-column.model";
import {HttpErrorsService} from "../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../services/utils/custom-notification.service";
import {RouteService} from "../../../../services/resources/route.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-routes-table',
  imports: [TranslateModule, TableComponent],
  template: `
    <app-table
      (doFilterRequest)="resourceService.getAll($event)"
      (urlParamsChange)="this.urlParams = $event"
      [allowMultiSelect]="false"
      [columns]="tableColumns"
      [data]="models()"
      [deleteLoadingIds]="this.deleteLoadingIds()"
      [filterFormGroup]="filterFormGroup"
      [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
      [loading]="resourceService.loading()"
      [pagination]="resourceService.paginationMeta()"
    />`
})
export class RoutesTableComponent extends AResourceTableComponent<RouteModel> {

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'duration_ms',
      'started_at',
      'finished_at'
    ]
  );
  tableColumns: TableColumnModel[] = [
    {
      name: 'ROUTES.STATE',
      selector: [{selector: 'status'}]
    },
    {
      name: 'ROUTES.DURATION_MS',
      selector: [{
        selector: 'durationMs',
        castFunction: (value: number) => this.minutesToHours(value)}],
      filterFormControl: this.filterFormGroup.get('duration_ms'),
      filterFormControlLabel: 'ROUTES.DURATION_MS',
      filterUrlParam: 'duration_ms'
      ,
    },
    {
      name: 'ROUTES.STARTED_AT',
      selector: [{selector: 'startedAt',
      castFunction: (value: string) => this.removeSeconds(value)}],
      filterFormControl: this.filterFormGroup.get('started_at'),
      filterFormControlLabel: 'ROUTES.STARTED_AT',
      filterUrlParam: 'started_at',
    },
    {
      name: 'ROUTES.FINISHED_AT',
      selector: [{selector: 'finishedAt',
        castFunction: (value: string) => this.removeSeconds(value)}],
      filterFormControl: this.filterFormGroup.get('finished_at'),
      filterFormControlLabel: 'ROUTES.FINISHED_AT',
      filterUrlParam: 'finished_at',
    },
    {
      buttons: [
        {
          iconClass: 'fas fa-map-marked-alt fa-lg',
          floating: true,
          outlined: true,
          color: 'secondary',
          onClick: ($event) => this.openSelectedRoute($event)
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]
  minutesToHours(minutes?: number | null): string {
    if (!minutes) return '-';

    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;

    return `${hours}h ${mins}m`;
  }

  removeSeconds(value?: string | null): string {
    if (!value) return '-';

    let date = new Date(value);

    return date.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  constructor(
    formBuilder: FormBuilder,
    public routeService: RouteService,
    private router: Router,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      routeService,
      httpErrorsService,
      notificationService,
      'ROUTES');
  }

  openSelectedRoute(routeId: number) {
    this.router.navigate(['/stops', routeId]);

  }
}
